module.exports = __webpack_public_path__ + "static/media/disability.252fad68.svg";